const brandDomains = [
	//31 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP
	{
		domain: 'www.yolo247.live',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'www.yolo247.pro',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247.world',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247in.live',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247experience.co',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247experience.online',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247experience.com',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247.site',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247.co',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247.live',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247.com',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},

	{
		domain: 'www.yolo247.net',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},

	{
		domain: 'www.yowo247.com',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247.pro',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247.world',
		id: 31,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'cashsite.gamestest.link',
		id: 31,
		type: 'CLIENT/AGENT',
		dev: 'STAGING',
		main: true
	},
	{
		domain: 'cashsite2.gamestest.link',
		id: 31,
		type: 'CLIENT/AGENT',
		dev: 'STAGING',
		main: true
	},
	{
		domain: 'preprod.yolo247.com',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.yolo247.site',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.yolo247.co',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.yolo247.net',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.yolo247.live',
		id: 31,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},

	//32 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP
	{
		domain: 'www.yolo247club.com',
		id: 32,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'www.yolo247.club',
		id: 32,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247club.co',
		id: 32,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.yolo247club.live',
		id: 32,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'preprod.yolo247.club',
		id: 32,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},

	{
		domain: 'www.yolo247club.co',
		id: 32,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'a-cashsite.gamestest.link',
		id: 32,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},

	//33 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP
	{
		domain: 'www.iw247.co',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'www.iw247.net',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'm.iw247.com',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.iw247.com',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.baaziadda.co',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	}, {
		domain: 'www.baaziadda.net',
		id: 33,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'betdaily.gamestest.link',
		id: 33,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},
	{
		domain: 'preprod.iw247.co',
		id: 33,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},

	//34 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP
	{
		domain: 'www.betdaily.club',
		id: 34,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'club-betdaily.gamestest.link',
		id: 34,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},
	{
		domain: 'preprod.betdaily.club',
		id: 34,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},


	//39 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP
	{
		domain: 'www.fomo7.co',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'www.fomo7.net',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.foma7.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.7fomo.net',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo27.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.7fomo.co',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo7.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.foma7.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo7.pro',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo7.live',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo11.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo15.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo16.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo7.site',
		id: 39,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'fomo7.gamestest.link',
		id: 39,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},
	{
		domain: 'preprod.fomo7.co',
		id: 39,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.fomo7.com',
		id: 39,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},

	//40 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP

	{
		domain: 'www.fomo7.xyz',
		id: 40,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'www.fomo7.club',
		id: 40,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo7.vip',
		id: 40,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fomo7.biz',
		id: 40,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'club-fomo7.gamestest.link',
		id: 40,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},
	{
		domain: 'preprod.fomo7.xyz',
		id: 40,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},

	//46 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP

	{
		domain: 'www.fun88.site',
		id: 46,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'www.fun88-ind.club',
		id: 46,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88ind.co',
		id: 46,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'preprod.fun88.site',
		id: 46,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'club-fun.gamestest.link',
		id: 46,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},

	//47 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP

	{
		domain: 'www.fun88.live',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'www.fun88ind.net',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88.app',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.88funinr.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88casinoindia.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88ind.in',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.playfuninr.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88-india.in',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88-inr.in',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88ind.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88official.co',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.thefun888.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.playatfun88.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.88fun.co',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'www.fun88.online',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'preprod.fun88.live',
		id: 47,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.fun88ind.net',
		id: 47,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.fun88ind.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.fun88.online',
		id: 47,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'fun88.gamestest.link',
		id: 47,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},
	{
		domain: 'www.gofun88.in',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},
	{
		domain: 'preprod.gofun88.in',
		id: 47,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.fun88ind.com',
		id: 47,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'www.fun88poker.online',
		id: 47,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},

	//61 : ALWAYS KEEP THE MAIN PRODUCTION URL AT THE TOP
	{
		domain: 'www.yolo247.io',
		id: 61,
		type: 'CLIENT',
		dev: 'PROD',
		main: true
	},
	{
		domain: 'crypto.gamestest.io',
		id: 61,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},
	{
		domain: 'crypto2.gamestest.io',
		id: 61,
		type: 'CLIENT',
		dev: 'STAGING',
		main: true
	},
	// {
	// 	domain: 'crypto.gamestest.link',
	// 	id: 61,
	// 	type: 'CLIENT',
	// 	dev: 'STAGING' 
	// },

	{
		domain: 'preprod.yolo247.io',
		id: 61,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'preprod.yolo247crypto.com',
		id: 61,
		type: 'CLIENT',
		dev: 'PRE-PROD',
		main: true
	},
	{
		domain: 'www.yolo247crypto.com',
		id: 61,
		type: 'CLIENT',
		dev: 'PROD',
		main: false
	},

	//////local host//////
	{
		domain: 'localhost:3000', 
		id: 39, 
		type: 'CLIENT/AGENT',
		dev: 'DEV',
		main: true
	},
	{
		domain: '5987-94-204-157-90.ngrok-free.app',
		id: 47,
		type: 'CLIENT',
		dev: 'DEV',
		main: false
	}
];


export default brandDomains;